import axios from 'axios';

export const getImages = async (apiUrl, region, queryParams, defaultQuery) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (queryParams && queryParams !== 'owner') {
    if (queryParams) {
      if (queryParams.includes('?')) {
        queryParams = queryParams.split('?');
        queryParams = '&' + queryParams[1];
      }
      queryParams = defaultQuery + queryParams;
    } else {
      queryParams = defaultQuery;
    }
  }

  if (queryParams && queryParams === 'owner' || (defaultQuery && defaultQuery === 'owner')) {
    if (region === 'core') {
      region = 'ams2'
    }
    let projectId = JSON.parse(localStorage.getItem('current_project'))[region];
    queryParams = `?owner=${projectId}&limit=1000&sort=name:asc`;
  }

  if (queryParams) {
    return axios.get(`${apiUrl}/v2/images${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/v2/images`, settings);
  }
}

export const getImageDetails = async (apiUrl, image_id, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2/images/${image_id}`, settings);
}

export const getImagesNext = async (apiUrl, nextUrl, region, queryParams, defaultQuery) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (defaultQuery) {
    if (queryParams) {
      if (queryParams.includes('?')) {
        queryParams = queryParams.split('?');
        queryParams = '&' + queryParams[1];
      }
      queryParams = defaultQuery + queryParams;
    } else {
      queryParams = defaultQuery;
    }
  }

  if (queryParams) {
    return axios.get(`${apiUrl}${nextUrl}${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}${nextUrl}`, settings);
  }
}

export const deleteImage = async (apiUrl, imageId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2/images/${imageId}`, settings);
}

export const createImage = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2/images`, data, settings);
}

export const addImageData = async (apiUrl, imageId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/octet-stream',
    }
  };

  return axios.put(`${apiUrl}/v2/images/${imageId}/file`, data, settings);
}
